<!--
 * @Description: 服务类型配置页面
 * @Author: sunhuihong
 * @Date: 2022-04-08 08:43:52
 * @LastEditTime: 2022-06-16 13:04:14
-->
<template>
  <div class="body">
    <el-row type="flex" class="row-bg service-type-main">
      <el-col :span="8" v-for="item in serviceTypeList" :key="item.id">
        <div class="grid-content bg-purple">
          <el-card class="box-card" :body-style="{ padding: '0px','background-color': '#FAFBFF',}">
            <div slot="header" class="clearfix">
              <span>{{ item.categoryName }}</span>
              <img src="../../assets/hsvccfg/add-plus.png"  style="float: right; width: 15px; padding-top: 3px"  
                @click="handleUpdate(item, 'add')"  alt="" />
            </div>
            <div v-for="items in item.hserviceTypeCfgList"  :key="items.id"  class="text item" >
              <div style="padding: 10px 20px;">
                <span>{{ items.name }}</span>
                <i class="el-icon-delete icon" style="color: #ff4500; margin-right: 5px; font-size: 16px"
                  @click="handleDelete(items)">
                </i>
                <i class="el-icon-edit icon" @click="handleUpdate(items, 'update')" style="font-size: 16px;"></i>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="title" :visible.sync="showHsvcCategoryCfgDialog" width="500px">
      <el-form :model="form" ref="formInline" :rules="rules" style="padding: 0 30px; text-align: left;">
        <el-form-item label="名称" prop="name" label-width="60px">
          <el-input v-model.trim="form.name"  placeholder="请输入类型名称" maxlength="5" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="descrition" label-width="60px">
          <el-input v-model.trim="form.descrition" maxlength="20" placeholder="请输入描述" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center" class="dialog-footer">
        <el-button @click="showHsvcCategoryCfgDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('formInline')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";

export default {
  name: "HsvcCategoryCfg",
  data() {
    return {
      serviceTypeList: [],
      updateItem: {},
      operate: "",
      title: "新增服务类型",
      form: {
        name: "",
        descrition: "",
      },
      showHsvcCategoryCfgDialog: false,
      rules: {
        name: [
          { required: true, message: "请输入服务类型名称", trigger: "blur" },
        ],
        descrition: [
          { required: true, message: "请输入服务类型描述", trigger: "blur" },
        ],
      },
    }
  },

  methods: {
    initData() {
      this.appAxios("GET", Constant.URL_GET_LIST_HSERVICE_TYPE_CFGS).then((result) => {
        if (result != null) {
          this.serviceTypeList = result.data;
        }
      })
    },

    deleteHserviceType(item) {
      let params = {id: item.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_HSERVICE_TYPE_CFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        this.$message({
          message: result.code == this.commonConst.RESTFUL_SUCC ? result.data : result.msg,
          type: result.code == this.commonConst.RESTFUL_SUCC ? "success" : 'warning'
        });
        this.initData();
      });
    },
    
    //删除
    handleDelete(item) {
      this.$confirm("确认是否删除名称为【" + item.name + "】的服务类型?", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        this.deleteHserviceType(item);  
      });
    },

    //新增服务类型配置
    handleSubmit(formInline) {
      this.$refs[formInline].validate((valid) => {
        if (!valid) return false;
        let url = this.operate == "add" ? Constant.URL_SAVE_HSERVICE_TYPE_CFG : Constant.URL_UPDATE_HSERVICE_TYPE_CFG;
        let method = this.operate == "add" ? "POST" : "PUT";
        let params = {
          category : this.updateItem.categoryType || this.updateItem.category,
          name : this.form.name,
          descrition : this.form.descrition
        };
        if(this.operate == "update") {
          params.id = this.updateItem.id
        }
        let fileMap = new Map();
        let param = {'name': 'hserviceTypeCfg', 'value': {...params}};
        let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				  param, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				  Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          url: url,
          method: method,
          header: header,
          param: esParams,
          contentType: this.commonConst.CNTYPE_JSON,
          files: fileMap
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }
          this.$message({ message: "保存成功", type: "success",});
          this.showHsvcCategoryCfgDialog = false;
          this.initData();
        });
      });
    },

    //编辑更新服务类型配置
    handleUpdate(item, type) {
      this.updateItem = item;
      this.operate = type;
      this.title = type == "update" ? "修改服务类型" : "新增服务类型";
      this.form.name = type == "update" ? item.name : "";
      this.form.descrition = type == "update" ? item.descrition : "";
      this.form.logoPath = (type == "update" && item.logoPath) 
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, item.logoPath) : "";
      this.showHsvcCategoryCfgDialog = true;
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "服务配置", text2: "服务类型配置" });
    this.initData();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.service-type-main {
  padding: 15px 10px;
  flex-wrap: wrap;
}

.service-type-main .el-col {
  padding: 0px 20px 20px 20px;
  text-align: left;
}

.service-type-main .el-col .el-card {
  box-shadow: none;
}

.service-type-main .el-col .el-card .el-card__header {
  height: 45px;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: bold;
  margin: 0;
}

.service-type-main .el-col .el-card .el-card__body {
  min-height: 160px;
  background: #fafbff;
  color: #333333;
  font-size: 14px;
  max-height:260px;
  overflow-y:auto;
  overflow-x:hidden;
}

.service-type-main .el-col .el-card .el-card__body .item {
  padding: 3px 0;
}

.service-type-main .el-col .el-card .el-card__body .item .icon {
  float: right;
  margin-right: 20px;
  display: none;
  cursor: pointer;
  color: #409eff;
  font-weight: bold;
}

.service-type-main .el-col .el-card .el-card__body .item:hover {
  background-color: rgb(245 247  250);  
}

.service-type-main .el-col .el-card .el-card__body .item:hover .icon {
  display: inline-block;
}

.logopath-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.logopath-uploader .el-upload:hover {
  border-color: #409eff;
}

.logopath-uploader .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.logopath-uploader .avatar {
  width: 40px;
  height: 40px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvccfg/HsvcCategoryCfg.vue